"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _Box = require("@nerdwallet/currency/components/Box");
var _Tooltip = require("@nerdwallet/currency/components/Tooltip");
var _Type = require("@nerdwallet/currency/components/Type");
var _disclaimerAdModule = _interopRequireDefault(require("./disclaimer-ad.module.css"));
var DisclaimerAd = function DisclaimerAd(_ref) {
  var _ref$displayFullWidth = _ref.displayFullWidth,
    displayFullWidth = _ref$displayFullWidth === void 0 ? false : _ref$displayFullWidth,
    _ref$justifyContentMo = _ref.justifyContentMobile,
    justifyContentMobile = _ref$justifyContentMo === void 0 ? 'center' : _ref$justifyContentMo,
    _ref$renderAd = _ref.renderAd,
    renderAd = _ref$renderAd === void 0 ? false : _ref$renderAd,
    text = _ref.text,
    tooltipContent = _ref.tooltipContent,
    _ref$tooltipPlacement = _ref.tooltipPlacement,
    tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement;
  return /*#__PURE__*/_react.default.createElement(_Box.Box, {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: {
      mobile: justifyContentMobile,
      desktop: 'flex-start'
    }
  }, renderAd && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    className: _disclaimerAdModule.default.containerText,
    marginRight: "2"
  }, /*#__PURE__*/_react.default.createElement(_Type.Type, {
    className: (0, _classes.default)('width-100'),
    size: "0"
  }, "AD")), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    className: (0, _classnames.default)(_disclaimerAdModule.default.containerText, (0, _defineProperty2.default)({}, _disclaimerAdModule.default.fullWidthText, displayFullWidth))
  }, /*#__PURE__*/_react.default.createElement(_Type.Type, {
    className: (0, _classes.default)('width-100'),
    size: "0"
  }, text), !!tooltipContent && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    content: tooltipContent,
    placement: tooltipPlacement
  })));
};
var _default = DisclaimerAd;
exports.default = _default;